<template>
  <CollapsibleCard
    :value="true"
    :padding="false"
    collapsibleIcon="mdi-hammer-wrench"
    collapsibleTitle="Tiltak"
    :total="total"
  >
    <template v-slot>
      <div v-if="!loading">
        <div
          class="caseCardContainer"
          v-for="(item, index) in data"
          :key="index"
        >
          <CaseCard
            :tile="true"
            :elevation="0"
            :title="item.title"
            :status="item.status"
            :color="getColor(item)"
            :deadline="item.timeLimit"
            :under-right="item.responsible"
            :under-left="item.projectName"
            @click="goTo(item)"
          >
            <template v-slot:title>
              {{ item.id }}
              {{ item.id && item.title ? "-" : "" }}
              {{ item.title }}
            </template>

            <template v-slot:chips>
              <div v-for="(chip, index) in getChips(item)" :key="index">
                <v-chip class="mr-2" :color="chip.color" small>
                  {{ chip.title }}
                </v-chip>
              </div>
            </template>

            <template v-slot:underLeft>
              {{ item.projectName }}
              {{ item.projectName && item.apartmentKey ? "-" : "" }}
              {{ item.apartmentKey }}
            </template>
          </CaseCard>
        </div>
      </div>
      <div v-if="loading">
        <div v-for="index in 5" :key="index">
          <CaseCard :loading="true" />
        </div>
      </div>

      <ShowCollapsibleCardBtns
        :projectId="projectId"
        :houseName="houseName"
        filterNameProject="projTable"
        filterNameHouse="apartmentKey"
        routeName="Actions"
      />
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";
import aberrationApi from "@/api/aberrationApi";

import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import ShowCollapsibleCardBtns from "@/components/shared/cards/ShowCollapsibleCardBtns.vue";
import CaseCard from "@/components/shared/cards/CaseCard.vue";

export default Vue.extend({
  name: "DashboardMeasures",
  props: {
    projectId: {
      default: "",
    },
    houseId: {
      default: null,
    },
    houseName: {
      default: null,
    },
  },
  data: () => ({
    data: [],
    total: 0,
    loading: true,
  }),
  async mounted() {
    await this.fetchData();
    this.$watch(
      () => this.$route.params,
      () => {
        // react to route changes...
        this.fetchData();
      }
    );
  },
  methods: {
    async fetchData() {
      var headers = [
        {
          text: "Status",
          value: "statusText",
          type: "string",
          show: true,
          filterValues: [1],
          filterClause: 0,
          filterName: "actionStatus",
          sortIndex: 2,
        },
        {
          text: "Frist",
          value: "timeLimit",
          type: "date",
          show: true,
          filterValues: null,
          filterClause: 0,
          filterName: "timeLimit",
          sortIndex: 4,
          dateType: "DD.MM.YYYY",
        },
        {
          text: "Ansvarlig",
          value: "responsible",
          type: "string",
          show: true,
          filterValues: [this.profile.id],
          filterClause: 0,
          filterName: "responsibleId",
          sortIndex: 6,
          disabled: true,
        },
        {
          text: "Opprettet",
          value: "createdDate",
          type: "date",
          show: true,
          filterValues: null,
          filterClause: 0,
          filterName: "createdDate",
          dateType: "DD.MM.YYYY",
        },
        {
          filterName: "projTable",
          filterValues: this.projectId ? [this.projectId] : "",
          show: true,
          type: "string",
        },
        {
          filterName: "projPhase",
          filterValues: this.houseId ? [this.houseId] : "",
          show: true,
          type: "string",
        },
      ];

      var data = {
        headers: headers,
        itemsPerPage: 3,
        page: 1,
        search: "",
        sortBy: ["timeLimit"],
        sortDesc: [false],
        hideLoader: true,
      };

      await aberrationApi
        .getActions(data)
        .then((response) => {
          this.data = response.items;
          this.total = response.totalCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goTo(item) {
      this.$router.push({ name: "Action", params: { id: item.id } });
    },
    getChips(item: any) {
      var data = [
        {
          title: item.statusText,
          color: item.color,
        },
      ];
      if (item.aberrationSeverity) {
        data.push({
          title: item.aberrationSeverity,
          color: "",
        });
      }

      return data;
    },
    getColor(item) {
      if (item?.color) {
        return item.color;
      } else if (item) {
        this.$set(item, "color", item.completedDate ? "success" : "warning");
      }
    },
    setColor(item) {
      this.$set(item, "color", item.completedDate ? "success" : "warning");
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
  },
  components: {
    CollapsibleCard,
    ShowCollapsibleCardBtns,
    CaseCard,
  },
});
</script>
